var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenDarkFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.31 340.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#24733a;}.cls-3{fill:#0c130f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.31,30.33c0-7.17-3.08-9.86-10.5-9.94s-1.64-.05-12.16,0c-9.62,0-10.46-6.6-10.46-6.6s-1-6.26-8.79-6.28-233,0-233,0a8,8,0,0,0-8,8V332.87a8,8,0,0,0,8,8H283.31a8,8,0,0,0,8-8S291.29,37.51,291.31,30.33ZM249.48,284a6,6,0,0,1-6,6H37.32a6,6,0,0,1-6-6V109.56a6,6,0,0,1,6-6H243.48a6,6,0,0,1,6,6Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.88,22.84c0-7.18-3.08-9.86-10.5-9.95s-1.64,0-12.15,0c-9.62,0-10.47-6.6-10.47-6.6S248.72,0,241,0,8,0,8,0A8,8,0,0,0,0,8V325.38a8,8,0,0,0,8,8H274.88a8,8,0,0,0,8-8S282.87,30,282.88,22.84ZM249.48,284a6,6,0,0,1-6,6H37.32a6,6,0,0,1-6-6V109.56a6,6,0,0,1,6-6H243.48a6,6,0,0,1,6,6Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,325.38A8,8,0,0,0,5.66,333V119.27H0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277,119.27V333.09a8,8,0,0,0,5.89-7.71V119.27Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.14,54.1A24.54,24.54,0,0,1,227.51,79l-174.66-.2a25.49,25.49,0,0,1-25.37-24.9A24.54,24.54,0,0,1,52.12,29l174.66.19A25.49,25.49,0,0,1,252.14,54.1Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.88,40.84v-4h-32a28.62,28.62,0,0,1,2.43,4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,36.84v4H25.89a27.53,27.53,0,0,1,2.25-4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,44.78v4H23.67a28,28,0,0,1,.79-4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.88,48.78v-4h-28a28,28,0,0,1,.94,4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.48,52.6H0v4H23.57c0-.44-.05-.87-.06-1.31Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.15,55.58c0,.34,0,.68,0,1h26.74v-4H256.11v.07Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,60.41v4H25.21a27,27,0,0,1-1.14-4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.88,64.41v-4h-27.1a26.57,26.57,0,0,1-1,4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.88,71.65v-4h-29.4a27.17,27.17,0,0,1-2.37,4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,67.65v4H29.19a27.62,27.62,0,0,1-2.54-4Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253,108.2a8,8,0,0,0-8-8H35.84a8,8,0,0,0-8,8l.52,177.05a8.06,8.06,0,0,0,8,8H245.53a8,8,0,0,0,8-8ZM249.48,284a6,6,0,0,1-6,6H37.32a6,6,0,0,1-6-6V109.56a6,6,0,0,1,6-6H243.48a6,6,0,0,1,6,6Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.44,318a5,5,0,0,0,7.81,0l11-12.79c2.15-2.51,1.21-4.56-2.09-4.56H128.56c-3.3,0-4.25,2.05-2.1,4.56Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDarkFace);
export default __webpack_public_path__ + "static/media/green-dark-face.9f2c9b0d93909ccbb7fd275a42694584.svg";
export { ForwardRef as ReactComponent };